// import LogoNaranja from '../../images/Logo-orange.png'

export default function Title(props) {
    return <div className="container__title"> <h1 className={props.class}>{props.title}</h1></div>;
}